//=include _owl.carousel.min.js
//=include _endlessriver.js

jQuery.fn.reverse = [].reverse;

$(document).ready(function() {
	// Gestion du scroll
	handle_scroll_index();
	/*$(window).scroll(function() {
		handle_scroll_index();
	});*/
	$(window).scroll(debounce(handle_scroll_index, 10));

	/*$('#carrousel_partenaires').owlCarousel({
		loop: true,
		lazyLoad: true,
		autoplay: true,
		autoplayTimeout: 3000,
		margin: 80,
		dots: false,
		nav: false,
		responsive: {
			0: {
				items: 3,
				margin: 30
			},
			768: {
				items: 6,
				margin: 60
			},
			1400: {
				items: 8,
				margin: 80
			}
		}
	});*/
	$("#carrousel_partenaires").endlessRiver({
		speed: 100,
		pause: false,
		buttons: false
	});

	$('#carrousel_studio').owlCarousel({
		loop: true,
		lazyLoad: true,
		autoplay: true,
		autoplayTimeout: 3000,
		items: 1,
		margin: 0,
		dots: false,
		nav: false,
		animateIn: 'fadeIn',
		animateOut: 'fadeOut'
	});

	$('.section_projets .projet').hover(function() {
		$('#background_projet').css({'background-image' : 'url(' + $(this).data('bg') + ')'});
		$('.section_projets .projet').removeClass('active');
		$(this).addClass('active');
	}, function() {
		$('.section_projets .projet').removeClass('active');
	});
});

function handle_scroll_index() {
	var scroll_top = $(window).scrollTop();
	var window_height = $(window).height();
	var section_projets_top = $('.section_projets').offset().top;
	var section_projets_height = $('.section_projets').innerHeight();

	// Section projets
	if (scroll_top + (window_height / 3 * 2) < section_projets_top) {
		// Before
		$('#background_projet').fadeOut();
	} else if (scroll_top + (window_height / 3 * 2) > section_projets_top && scroll_top + (window_height / 4 * 3) < section_projets_top + section_projets_height) {
		// Inside
		$('#background_projet').fadeIn();
		$('.section_projets .projet').reverse().each(function() {
			if (scroll_top + (window_height / 2) > $(this).offset().top) {
				$('#background_projet').css({'background-image' : 'url(' + $(this).data('bg') + ')'});
				$('.section_projets .projet').removeClass('active');
				$(this).addClass('active');
				return false;
			}
		});
	} else if (scroll_top + (window_height / 4 * 3) > section_projets_top + section_projets_height) {
		// After
		$('#background_projet').fadeOut();
	}
}
